import {Evaluation} from "./evaluation";

import template from './evaluation.twig';
import tabs_template from './tabs.twig'

export default class RepEvaluation extends Evaluation
{
    submit_evaluation(event, evalDom){
        event.preventDefault();
        let form = $(event.target).closest('form');
        this.form = form;

        let missing_required = this.highlight_missing_required();
        if(missing_required) {
            return;
        }

        let answers = [];
        this.dom.find("input").each((i, element) => {
            if($(element).is(":checked")) {
                answers.push(['check', $(element).attr("name"), $(element).val()]);
            }
        });

        this.dom.find("textarea").each((i, element) => {
            answers.push(['text', $(element).attr('name'), $(element).val()]);
        });

        let data = {};
        $.each(form.serializeArray(), (_, kv) => {
            if (kv.name in data) {
                data[kv.name] = $.makeArray(data[kv.name]);
                data[kv.name].push(kv.value);
            }
            else {
                data[kv.name] = kv.value;
            }
        });

        data.answers = answers;
        data.html = this.dom.html();

        $.ajax({
            url	: "api/evaluation",
            type: "POST",
            data: data,
            dataType: 'json',
            success	: (data) => {
                $(form).find('.evaluation_waiting_message').css('display', 'none');
                if (data.success)
                {
                    $(form).find(".missing_required_message").hide();
                    $(form).find(".evaluation_success_message").show();

                    if (this.submit_callback)
                    {
                        this.submit_callback(this.submit_callback_params);
                    }

                    $('.eval-complete').show();
                    $('#eval_button').removeClass('btn-dark').addClass('btn-primary');
                }
                else
                {
                    $(form).find(".evaluation_success_message").hide();
                    $(form).find(".missing_required_message").show();
                }
            },
            error: () => {
                $(form).find(".evaluation_success_message").hide();
                $(form).find(".missing_required_message").show();
            }
        });
    }

    fetch_evaluation_html(target, meeting_id, callback, callback_params){
        $.ajax({
            url: "api/evaluation/data",
            type: "GET",
            data: {
                meeting_id	: meeting_id
            }
        }).then((data) => {
            let html = $(twig({data: tabs_template}).render({
                eval_mode: '',
                ...data
            }));
            this.dom = this.apply_evaluation_html(html, callback, callback_params);
            this.data = data;

            Object.entries(data.evaluations).forEach(entry => {
                let evaluation = entry[1];
                let id = '#eval_tab_'+evaluation.topic_id+'_'+evaluation.speaker_id+'_'+evaluation.eval_type+'_'+evaluation.eval_id;

                let evalDom = $(twig({data: template}).render({form_index: entry[0], ...evaluation}));

                this.populate_answers(evalDom.find('form'));
                this.dom.find(id).append(evalDom);
            })

            this.processMode();
            target.append(this.dom);
            this.dom.find(".nav-link").first().trigger('click');
        });
    }
}
